<script>
	import { Router, Route } from "svelte-routing";
	import UserCreateForm from "./UserCreateForm.svelte";
	import EditUserForm from "./EditUserForm.svelte";
	import Manage from "./Manage/Manage.svelte";
</script>

<Router url="/">
	<Route path="/" component={Manage} />
	<Route path="/create" component={UserCreateForm} />
	<Route path="/edit/:userId" let:params>
		<EditUserForm userId={params.userId} />
	</Route>
</Router>
